import React from 'react';
import Icon from '../../../components/AppIcon';

const ContentAnalytics = () => {
  const stats = [
    {
      label: 'Total Views',
      value: '12.4K',
      icon: 'Eye',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10'
    },
    {
      label: 'Downloads',
      value: '3.2K',
      icon: 'Download',
      color: 'text-green-500',
      bgColor: 'bg-green-500/10'
    },
    {
      label: 'Avg Rating',
      value: '4.7',
      icon: 'Star',
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-500/10'
    },
    {
      label: 'Completions',
      value: '2.8K',
      icon: 'CheckCircle',
      color: 'text-purple-500',
      bgColor: 'bg-purple-500/10'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="text-lg font-semibold text-foreground mb-4">Content Analytics</h3>
      <div className="space-y-3">
        {stats?.map((stat, index) => (
          <div key={index} className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-3">
              <div className={`w-8 h-8 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
                <Icon name={stat?.icon} size={16} className={stat?.color} />
              </div>
              <span className="text-sm text-muted-foreground">{stat?.label}</span>
            </div>
            <span className="text-lg font-bold text-foreground">{stat?.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentAnalytics;